/**
 * Détection de plateforme pour adaptation du comportement UI
 * Utilisé pour déterminer le tab par défaut selon l'appareil (mobile vs desktop)
 */

/**
 * Détecte le type de plateforme et d'appareil
 * @returns {Object} Informations sur la plateforme
 */
export function detectPlatform() {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  const isInApp = window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;

  return {
    isMobile,
    isInApp,
    platform: isMobile ? 'mobile' : 'desktop'
  };
}

/**
 * Détermine la méthode d'authentification par défaut selon la plateforme
 * Sur mobile: SMS (plus naturel pour les utilisateurs mobiles)
 * Sur desktop: Email ou paramètre URL
 * @returns {string} Méthode par défaut ('email', 'sms', 'password')
 */
export function getDefaultMethodForPlatform() {
  const platform = detectPlatform();

  // Sur mobile, forcer le tab SMS par défaut
  if (platform.isMobile) {
    return 'sms';
  }

  // Sur desktop, utiliser le paramètre URL ou 'email' par défaut
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('method') || 'email';
}
